import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


export interface PriorityBreakdown {
  total: number;
  [priority: string]: number;
}

export interface StatusStats {
  [status: string]: PriorityBreakdown;
}

export interface DashboardStats {
  inquiries: StatusStats;
  corrections: StatusStats;
  withdrawals: StatusStats;
  transactions: any[];
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  constructor(private http: HttpClient) {}

  getStats(): Observable<DashboardStats> {
    return this.http.get<DashboardStats>(`${environment.apiUrl}/admin/dashboard`);
  }

}
